module.exports = __webpack_public_path__ + "img/yml_gallery9.4ec66d80.jpg";